var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.$root.translate("Payment Info")))]})],2),_c('card',{staticClass:"stripe-card",class:{ cc_ready: _vm.cc_ready },attrs:{"id":_vm.id,"stripe":_vm.stripe_key,"options":_vm.stripe_options},on:{"change":_vm.card_changed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }